import { Box } from '@shopify/polaris';
import { useMemo } from 'react';
import { cls } from '~/utils';

interface GVariantProps {
  variant: string;
  size: 'xs' | 'sm' | 'md' | 'lg';
  tone?: 'active' | 'subdued' | 'inactive';
}

export const GVariant = ({ variant, size, tone }: GVariantProps) => {
  const sizeIcon = useMemo(() => {
    switch (size) {
      case 'xs':
        return '20px';
      case 'sm':
        return '24px';
      case 'md':
        return '28px';
      case 'lg':
        return '32px';
      default:
        return '28px';
    }
  }, [size]);

  const textColor: string = cls({
    'text-variant-a': tone === 'active',
    'text-variant-subdued': tone === 'subdued',
    'text-variant-b': !tone || tone === 'inactive',
  });

  const textSize: string = useMemo(() => {
    switch (size) {
      case 'xs':
        return 'Polaris-Text--bodyXs';
      case 'sm':
        return 'Polaris-Text--bodySm';
      case 'md':
        return 'Polaris-Text--headingMd';
      case 'lg':
        return 'Polaris-Text--headingMd';
      default:
        return 'Polaris-Text--headingMd';
    }
  }, [size]);

  return (
    <Box minHeight={sizeIcon} minWidth={sizeIcon} width={sizeIcon} borderRadius="full">
      <div className="Polaris-GVariantBadge-Icon" style={{ height: sizeIcon }}>
        <h2 className={`Polaris-Text--headingMd Polaris-Text--semibold ${textColor} ${textSize}`}>
          {variant}
        </h2>
      </div>
    </Box>
  );
};
